
function initGallery() {
  const scroller = qs(".gallery__scroller");
  const slides = qsa(".gallery__slide");
  const dots = qsa(".gallery__dot");
  const thumbs = qsa(".gallery__thumb");
  if (!scroller || !slides.length) return;

  const setActive = (activeIndex) => {
    slides.forEach((slide, index) => slide.classList.toggle("is-active", index === activeIndex));
    [...dots, ...thumbs].forEach((control) => {
      const index = Number(control.dataset.galleryIndex);
      const isActive = index === activeIndex;
      control.classList.toggle("is-active", isActive);
      if (isActive) {
        control.setAttribute("aria-current", "true");
      } else {
        control.removeAttribute("aria-current");
      }
    });
  };

  const goToSlide = (index) => {
    const slide = slides[index];
    if (!slide) return;
    setActive(index);
    scroller.scrollTo({ left: slide.offsetLeft - scroller.offsetLeft, behavior: "smooth" });
  };

  slides.forEach((slide, index) => {
    slide.addEventListener("click", () => setActive(index));
  });

  [...dots, ...thumbs].forEach((control) => {
    control.addEventListener("click", () => {
      goToSlide(Number(control.dataset.galleryIndex));
    });
  });

  let ticking = false;
  scroller.addEventListener("scroll", () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      const scrollerRect = scroller.getBoundingClientRect();
      const center = scrollerRect.left + scrollerRect.width / 2;
      const active = slides.reduce((closest, slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const distance = Math.abs(slideRect.left + slideRect.width / 2 - center);
        return distance < closest.distance ? { index, distance } : closest;
      }, { index: 0, distance: Number.POSITIVE_INFINITY });

      setActive(active.index);
      ticking = false;
    });
  });
}

function initOptions() {
  qsa(".pack-card").forEach((card) => {
    card.addEventListener("click", (event) => {
      if (event.target.closest("select")) return;
      selectPack(card);
    });
    card.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      selectPack(card);
    });
  });

  qsa(".pack-color-select").forEach((select) => {
    select.addEventListener("change", () => {
      const slotIndex = Number(select.dataset.packColor || 0);
      state.colors[slotIndex] = select.value;
      state.color = state.colors[0];
      updateSelection();
      syncVariantUrl();
    });
  });
}

function initTabs() {
  qsa(".result-panel").forEach((panel) => {
    panel.hidden = !panel.classList.contains("is-active");
  });

  qsa(".tab").forEach((button) => {
    button.addEventListener("click", () => {
      qsa(".tab").forEach((tab) => {
        tab.classList.remove("is-active");
        tab.setAttribute("aria-selected", "false");
      });
      qsa(".result-panel").forEach((panel) => {
        panel.classList.remove("is-active");
        panel.hidden = true;
      });
      button.classList.add("is-active");
      button.setAttribute("aria-selected", "true");
      const panel = qs(`#${button.dataset.target}`);
      panel.hidden = false;
      panel.classList.add("is-active");
    });
  });
}

function initResultsMarquee() {
  const root = qs("[data-results-marquee]");
  if (!root || root.dataset.initialized === "true") return;
  const viewport = qs("[data-results-viewport]", root);
  const track = qs("[data-results-track]", root);
  const group = qs("[data-results-group]", root);
  const toggle = qs("[data-results-toggle]", root);
  if (!viewport || !track || !group || !toggle) return;
  root.dataset.initialized = "true";

  // Keep exactly one instance of each supplied before/after pair.

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const hoverDevice = window.matchMedia("(hover: hover)");
  let manuallyPaused = reducedMotion.matches;
  let hovering = false;
  let focused = false;
  let pointerDown = false;
  let inView = true;
  let resumeAfter = 0;
  let previousTime = 0;
  let maxPosition = Math.max(0, group.getBoundingClientRect().width - viewport.clientWidth);
  let direction = 1;
  let position = viewport.scrollLeft;
  let lastWrittenPosition = position;

  const updateToggle = () => {
    toggle.textContent = manuallyPaused ? "Reanudar movimiento" : "Pausar movimiento";
    toggle.setAttribute("aria-pressed", String(manuallyPaused));
  };
  const refreshWidth = () => {
    maxPosition = Math.max(0, group.getBoundingClientRect().width - viewport.clientWidth);
    position = viewport.scrollLeft;
  };
  const userInteraction = () => {
    resumeAfter = performance.now() + 2400;
    position = viewport.scrollLeft;
  };

  toggle.hidden = false;
  updateToggle();
  toggle.addEventListener("click", () => {
    manuallyPaused = !manuallyPaused;
    previousTime = 0;
    updateToggle();
  });
  viewport.addEventListener("mouseenter", () => { hovering = hoverDevice.matches; });
  viewport.addEventListener("mouseleave", () => { hovering = false; });
  viewport.addEventListener("focusin", () => { focused = true; });
  viewport.addEventListener("focusout", (event) => {
    focused = viewport.contains(event.relatedTarget);
  });
  viewport.addEventListener("pointerdown", () => { pointerDown = true; userInteraction(); }, { passive: true });
  window.addEventListener("pointerup", () => {
    if (!pointerDown) return;
    pointerDown = false;
    userInteraction();
  }, { passive: true });
  viewport.addEventListener("pointercancel", () => { pointerDown = false; userInteraction(); }, { passive: true });
  viewport.addEventListener("wheel", userInteraction, { passive: true });
  viewport.addEventListener("keydown", userInteraction);
  viewport.addEventListener("scroll", () => {
    // Native touch momentum, keyboard scrolling and scrollbar dragging remain
    // native. Programmatic fractional steps should not pause the animation.
    if (Math.abs(viewport.scrollLeft - lastWrittenPosition) > 1) userInteraction();
  }, { passive: true });
  const onReducedMotionChange = () => {
    if (reducedMotion.matches) manuallyPaused = true;
    previousTime = 0;
    updateToggle();
  };
  if (reducedMotion.addEventListener) reducedMotion.addEventListener("change", onReducedMotionChange);
  else reducedMotion.addListener(onReducedMotionChange);
  if ("ResizeObserver" in window) new ResizeObserver(refreshWidth).observe(group);
  else window.addEventListener("resize", refreshWidth);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver((entries) => {
      inView = entries[0].isIntersecting;
      previousTime = 0;
    }, { rootMargin: "100px" }).observe(root);
  }
  const animate = (time) => {
    if (!root.isConnected) return;
    const elapsed = previousTime ? Math.min(time - previousTime, 50) : 0;
    previousTime = time;
    const paused = manuallyPaused || hovering || focused || pointerDown || !inView || document.hidden || time < resumeAfter;
    if (!paused && maxPosition > 0) {
      position += elapsed * 0.022 * direction;
      if (position >= maxPosition) {
        position = maxPosition;
        direction = -1;
        resumeAfter = time + 1600;
      } else if (position <= 0) {
        position = 0;
        direction = 1;
        resumeAfter = time + 1600;
      }
      viewport.scrollLeft = position;
      lastWrittenPosition = viewport.scrollLeft;
    } else {
      position = viewport.scrollLeft;
    }
    window.requestAnimationFrame(animate);
  };
  window.requestAnimationFrame(animate);
}

function openLightbox(event) {
  const box = qs("#lightbox");
  const triggerImage = event && event.currentTarget
    ? qs("img", event.currentTarget)
    : null;
  const sourceImage = triggerImage || qs(".gallery__slide.is-active img") || qs("#mainImage");
  qs("#lightboxImage").src = sourceImage.currentSrc || sourceImage.src;
  qs("#lightboxImage").alt = sourceImage.alt;
  box.classList.add("open");
  box.setAttribute("aria-hidden", "false");
  document.body.classList.add("no-scroll");
}

function closeLightbox() {
  const box = qs("#lightbox");
  box.classList.remove("open");
  box.setAttribute("aria-hidden", "true");
  document.body.classList.remove("no-scroll");
}

async function openCart(event) {
  const variant = syncVariantPricing();

  if (variant) {
    const button = event && event.currentTarget;
    const originalText = button ? button.textContent : "";

    try {
      if (button) {
        button.disabled = true;
        button.textContent = "Agregando...";
      }

      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
      });

      const item = {
        id: variant.id,
        quantity: 1,
      };

      const colors = selectedColors();
      const properties = {};
      if (colors.length > 1) {
        colors.forEach((color, index) => {
          properties[`Color ${index + 1}`] = color;
        });
      }
      if (packCount() > 1) {
        properties.Incluye = "+ Acondicionador potenciador de regalo";
      }
      if (Object.keys(properties).length) {
        item.properties = properties;
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [item],
        }),
      });

      if (!response.ok) throw new Error("No se pudo agregar al carrito");
      window.location.href = "/checkout";
      return;
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
      window.location.href = "/cart";
      return;
    }
  }

  state.cartCount += 1;
  if (qs("#cartCount")) qs("#cartCount").textContent = state.cartCount;
  updateSelection();
  const drawer = qs("#cartDrawer");
  if (!drawer) return;
  drawer.classList.add("open");
  drawer.setAttribute("aria-hidden", "false");
  document.body.classList.add("no-scroll");
}

function closeCart() {
  const drawer = qs("#cartDrawer");
  if (!drawer) return;
  drawer.classList.remove("open");
  drawer.setAttribute("aria-hidden", "true");
  document.body.classList.remove("no-scroll");
}

function initOverlays() {
  qsa("[data-open-lightbox]").forEach((button) => button.addEventListener("click", openLightbox));
  qsa("[data-close-lightbox]").forEach((button) => button.addEventListener("click", closeLightbox));
  if (qs("#lightbox")) {
    qs("#lightbox").addEventListener("click", (event) => {
      if (event.target.id === "lightbox") closeLightbox();
    });
  }

  qsa("[data-open-cart]").forEach((button) => button.addEventListener("click", openCart));
  qsa("[data-close-cart]").forEach((button) => button.addEventListener("click", closeCart));
  if (qs("#cartDrawer")) {
    qs("#cartDrawer").addEventListener("click", (event) => {
      if (event.target.id === "cartDrawer") closeCart();
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeLightbox();
    closeCart();
  });
}

function stars(count) {
  return "★★★★★".slice(0, count) + "☆☆☆☆☆".slice(0, 5 - count);
}

function isLocalReviewsPreview() {
  return window.TONOMAX_LOCAL_PREVIEW === true;
}

function visibleReviews() {
  const additional = isLocalReviewsPreview() && Array.isArray(window.TONOMAX_LOCAL_REVIEW_DRAFTS)
    ? window.TONOMAX_LOCAL_REVIEW_DRAFTS
    : additionalReviews;
  const drafts = additional.filter((review) => review && review.draft === true);
  const entries = [];
  for (let index = 0; index < Math.max(reviews.length, drafts.length); index += 1) {
    if (reviews[index]) entries.push(reviews[index]);
    if (drafts[index]) entries.push(drafts[index]);
  }
  return entries;
}

function escapeReviewHtml(value) {
  return String(value == null ? "" : value).replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[character]);
}

function renderReviews() {
  const list = qs("#reviewList");
  if (!list) return;
  const entries = visibleReviews();
  const local = isLocalReviewsPreview();
  const end = entries.length;

  for (let i = shownReviews; i < end; i += 1) {
    const review = entries[i];
    const draft = review.draft === true;
    const photo = draft && review.img
      ? (local && window.TONOMAX_LOCAL_REVIEW_ASSETS
        ? window.TONOMAX_LOCAL_REVIEW_ASSETS[review.img]
        : assetPath(review.img))
      : null;
    const article = document.createElement("article");
    article.className = "review" + (photo ? " review--with-photo" : " review--text-only") + (draft ? " review--draft" : "");
    article.setAttribute("data-review-kind", draft ? "draft" : "existing");
    const date = !draft && review.date ? `<span class="review__date">${escapeReviewHtml(review.date)}</span>` : "";
    const rating = !draft && Number.isInteger(review.stars) && review.stars >= 1 && review.stars <= 5
      ? `<div class="stars" aria-label="${review.stars} de 5 estrellas">${stars(review.stars)}</div>`
      : "";
    const heading = draft ? "" : `
        <div class="review__head">
          <span class="review__name">${escapeReviewHtml(review.name)}</span>
          ${date}
        </div>`;
    const imageAlt = (review.imageAlt || "TonoMax").replace(/^Foto generada para maqueta:\s*/, "");
    const image = photo ? `
      <figure class="review__photo">
        <img src="${escapeReviewHtml(photo)}" alt="${escapeReviewHtml(imageAlt)}" width="1254" height="1254" loading="lazy" decoding="async">
      </figure>` : "";
    article.innerHTML = `
      <div class="review__body">
        ${heading}
        ${rating}
        <p>${escapeReviewHtml(review.text)}</p>
      </div>
      ${image}
    `;
    list.appendChild(article);
  }

  shownReviews = end;
}

function initReviews() {
  const list = qs("#reviewList");
  const loadMore = qs("#loadReviews");
  if (!list || !loadMore || list.dataset.initialized === "true") return;
  list.dataset.initialized = "true";
  renderReviews();
}

function initForms() {
  qsa(".contact-form").forEach((form) => {
    form.addEventListener("submit", () => {
      const button = form.querySelector("button");
      if (!button || !form.checkValidity()) return;
      button.textContent = "Enviando...";
      button.disabled = true;
    });
  });
}

function initLiveViewers() {
  const element = qs("[data-live-viewers-count]");
  if (!element) return;

  const min = 18;
  const max = 37;
  const key = "tonomaxLiveViewers";
  const stored = Number(sessionStorage.getItem(key));
  let count = Number.isFinite(stored) ? stored : 24 + Math.floor(Math.random() * 5) - 2;

  const render = () => {
    count = Math.max(min, Math.min(max, count));
    element.textContent = String(count);
    sessionStorage.setItem(key, String(count));
  };

  const schedule = () => {
    window.setTimeout(() => {
      const movement = Math.floor(Math.random() * 5) - 2;
      count += movement === 0 ? 1 : movement;
      render();
      schedule();
    }, 4500 + Math.floor(Math.random() * 4500));
  };

  render();
  schedule();
}

document.addEventListener("DOMContentLoaded", () => {
  if (qs("#year")) qs("#year").textContent = new Date().getFullYear();
  initGallery();
  initOptions();
  initTabs();
  initResultsMarquee();
  initOverlays();
  initReviews();
  initForms();
  initLiveViewers();
  if (qs(".pack-card.is-active")) {
    hydrateSelectionFromShopify();
    updateSelection();
  }
});
